<template>
  <div class="step-form">
    <div class="step-row">
      <div :style="progressStyle(i)" v-for="i in totalPages" :key="i" class="progess"></div>
    </div>

    <div :style="formBoxStyle(0)" class="step-formbox">
      <h3>Event erstellen</h3>
      <div class="step-grid">
        <div class="step-descripton">
          <p class="description">Titel:</p>
        </div>
        <div class="step-descripton">
          <b-form-input v-model="title"
                           id="title"
                           placeholder="Eventtitel..."
          ></b-form-input>
        </div>
        <div class="step-descripton">
          <p class="description"> Sportart auswählen:</p>
        </div>
        <div class="step-content">
          <b-form-select id="sportType" v-model="selected" :state="validationState['sportType']" @change="refreshfields"
                         :options="options"></b-form-select>
        </div>
        <div class="step-descripton">
          <p class="description"> Veranstaltungsort:</p>
        </div>
        <div class="step-content">
          <b-form-input id="sportField" v-model="selectedField" :state="validationState['sportField']"
                        list="fields"></b-form-input>
          <p>Beispiel: Sporthalle Münsterland Ost</p>
          <datalist id="fields">
            <option v-for="(field, indx) in fields" :value="field.sportId" :key="indx">{{ field.name }}</option>
          </datalist>
        </div>
        <div class="step-descripton">
          <p class="description"> Datum:</p>
        </div>
        <div class="step-content">
          <b-form-datepicker id="date" :state="validationState['date']" locale="de" v-model="date"
                             class="mb-2"></b-form-datepicker>
        </div>
        <div class="step-descripton">
          <p class="description"> Startzeitpunkt:</p>
        </div>
        <div class="step-content">
          <b-input-group class="mb-3">
            <b-form-input
                v-model="startTime"
                :state="validationState['startTime']"
                type="text"
                placeholder="HH:mm"
                id="startTime"
            ></b-form-input>
            <b-input-group-append>
              <b-form-timepicker
                  v-model="startTime"
                  button-only
                  right
                  locale="de"
                  aria-controls="example-input"
              ></b-form-timepicker>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="step-descripton">
          <p class="description"> Endzeitpunkt:</p>
        </div>
        <div class="step-content">
          <b-input-group class="mb-3">
            <b-form-input
                id="endTime"
                :state="validationState['endTime']"
                v-model="endTime"
                type="text"
                placeholder="HH:mm"
            ></b-form-input>
            <b-input-group-append>
              <b-form-timepicker
                  v-model="endTime"
                  button-only
                  right
                  locale="de"
                  aria-controls="example-input"
              ></b-form-timepicker>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
    </div>

    <div :style="formBoxStyle(1)" class="step-formbox">
      <h3>Ergänzende Angaben</h3>
      <div class="step-grid">

        <div class="step-descripton">
          <p class="description"> Öffentlich
            <b-icon icon="info-circle" id="info-state"></b-icon>
          </p>
          <b-tooltip target="info-state" triggers="hover">
            Private Events sind nur für dich einsehbar.
          </b-tooltip>
        </div>
        <div class="step-content">
          <b-form-checkbox id="stateEvent" :state="validationState['stateEvent']" v-model="stateEvent" name="stateEvent"
                           switch>
          </b-form-checkbox>
        </div>
        <div class="step-descripton">
          <p class="description"> Spieleranzahl
          </p>
        </div>
        <div class="step-content">
          <b-form-input class="participant" :state="validationState['minParticipants']" id="minParticipant"
                        v-model="minParticipant" type="number"></b-form-input>
          <p> bis </p>
          <b-form-input class="participant" :state="validationState['maxParticipants']" id="maxParticipant"
                        v-model="maxParticipant" type="number"></b-form-input>
        </div>

        <div class="step-descripton">
          <p class="description"> Schwierigkeit:</p>
        </div>
        <div class="step-content">
          <b-form-radio-group
              id="difficulty"
              :state="validationState['difficulty']"
              v-model="difficulty"
              :options="difficultyOptions"
              buttons
              button-variant="outline-primary"
              size="md"
              name="radio-btn-outline"
          ></b-form-radio-group>
        </div>
        <div class="step-descripton">
          <p class="description">Suchzeitpunktsende</p>
        </div>
        <div class="step-content">
          <b-input-group class="searchEnd">
            <b-form-input
                id="searchEndDate"
                :state="validationState['searchEndDate']"
                v-model="searchEndDate"
                type="text"
                placeholder="YYYY-MM-DD"
                autocomplete="off"
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                  v-model="searchEndDate"
                  button-only
                  right
                  locale="de"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
          <b-input-group class="searchEnd">
            <b-form-input
                id="searchEndTime"
                :state="validationState['searchEndTime']"
                v-model="searchEndTime"
                type="text"
                placeholder="HH:mm"
            ></b-form-input>
            <b-input-group-append>
              <b-form-timepicker
                  v-model="searchEndTime"
                  button-only
                  right
                  locale="de"
                  aria-controls="example-input"
              ></b-form-timepicker>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="step-descripton">
          <p class="description">Zusatz-Informationen: </p>
        </div>
        <div class="step-content">
          <b-form-textarea v-model="description"
                           :state="validationState['description']"
                           id="description"
                           placeholder="Schreibe etwas für deine Mitspieler.."
          ></b-form-textarea>
        </div>
      </div>
    </div>

    <div :style="formBoxStyle(2)" class="step-formbox">
      <h3>Übersicht</h3>
      <table style="margin: 0 auto">
        <tr>
          <th>Beschreibung</th>
          <th>Eingabe</th>
        </tr>
        <tr>
          <td>Sportplatz</td>
          <td>{{ selectedField }}</td>
        </tr>
        <tr>
          <td>Sportart</td>
          <td>{{ selected }}</td>
        </tr>
        <tr>
          <td>Datum</td>
          <td>{{ date }}</td>
        </tr>
        <tr>
          <td>Zeitraum</td>
          <td>{{ startTime }} bis {{ endTime }} ({{ calcDuration() }} Min.)</td>
        </tr>
        <tr>
          <td>Gesamtkosten</td>
          <td>{{ getTotalPrice() }}</td>
        </tr>
        <tr>
          <td>Max. Kosten pro Person</td>
          <td>{{ getMaxPricePerPerson() }}</td>
        </tr>
        <tr>
          <td>Suche endet am</td>
          <td>{{ searchEndDate }} {{ searchEndTime }}</td>
        </tr>
      </table>
    </div>

    <div class="step-btns">
      <button v-if="currentTab>0" @click="nextPrev(-1)">Zurück</button>
      <button v-if="isLast" @click="addevent">Erstellen</button>
      <b-button :disabled="!disabled" v-else @click="nextPrev(1)">Nächste</b-button>
    </div>
  </div>
</template>

<script>

import {sportService} from "@/services/sports.service"
import {fieldService} from "@/services/field.service"
import {eventService} from "@/services/event.service"
import {utilsService} from "@/services/utils.service";
import {validationUtilsService} from "@/services/validation-utils.service";

export default {
  name: "createevent",
  data() {
    return {
      validation: {
        submitted: false,
        sportField: {
          dirty: false,
          required: true,
          requiredMessage: "Bitte Feld auswählen"
        },
        sportType: {
          dirty: false,
          required: true,
          requiredMessage: "Bitte Sportart auswählen"
        },
        date: {
          dirty: false,
          required: true,
        },
        startTime: {
          dirty: false,
          required: true,
        },
        endTime: {
          dirty: false,
          required: true,
        },
        searchEndDate: {
          dirty: false,
          required: true,
        },
        searchEndTime: {
          dirty: false,
          required: true,
        },
        difficulty: {
          dirty: false,
          required: true,
        },
        stateEvent: {
          dirty: false,
          required: true,
        },
        description: {
          dirty: false,
          required: true,
        },
        minParticipants: {
          dirty: false,
          required: true,
        },
        maxParticipants: {
          dirty: false,
          required: true,
        },
      },
      currentTab: 0,
      totalPages: 0,
      date: '',
      maxDistance: 0,
      stateEvent: true,
      selected: null,
      options: [],
      fields: [],
      selectedField: "",
      startTime: "12:00:00",
      endTime: "14:00:00",
      searchEndDate: "",
      searchEndTime: "",
      difficulty: 1,
      description: "",
      title: "",
      minParticipant: 1,
      maxParticipant: 10,
      type: null,
      search: null,
      difficultyOptions: [
        {text: 'Anfänger', value: '1'},
        {text: 'Fortgeschritten', value: '2'},
        {text: 'Profi', value: '3'},
        {text: 'Für Alle', value: '4'}
      ]
    }
  },
  created() {
    sportService.getSports().then(res => {
      res.items.forEach(sport => {
        this.options.push({
          value: sport.sportId,
          text: sport.name
        })
      })
    })
  },
  mounted() {
    this.totalPages = document.getElementsByClassName("step-formbox").length
  },
  computed: {
    isLast() {
      let x = document.getElementsByClassName("step-formbox")
      return (this.currentTab === (x.length - 1))
    },

    disabled: function () {
      if (this.currentTab === 0 && this.selected && this.selectedField && this.date && this.startTime <= this.endTime) {
        return true;
      } else if (this.currentTab === 1 && this.searchEndTime && this.searchEndDate && this.searchEndDate < this.date) {
        return true;
      } else {
        return false;
      }
    },
    totalPrice() {
      let pricePerHour = -1
      for (let i = 0; i < this.fields.length; i++) {
        let field = this.fields[i]
        if (String(field["fieldId"]) === String(this.selectedField)) {
          pricePerHour = field["pricePerHour"]
        }
      }
      if (pricePerHour < 0) {
        // FEHLAA. KEIN BEKANNTES FELD
      }
      return (this.calcDuration() / 60) * (pricePerHour / 100)
    }
  },
  methods: {
    refreshfields() {
      fieldService.getFields(this.maxDistance, this.selected).then(res => {
        this.fields = res.items
      })
      this.selectedField = ""
    },
    validationState() {
      let result = {}

      for (let key in this.validation) {
        if (key === "submitted") {
          continue
        }
        let element = document.getElementById(key)
        if(!element){
          continue
        }
        let value = element.value
        result[key] = validationUtilsService.validateField(this.validation, key, value, null)
      }
      return result
    },
    getTotalPrice() {
      return utilsService.formatCurrency(this.totalPrice)
    },
    getMaxPricePerPerson() {
      let price = this.totalPrice / this.minParticipant
      return utilsService.formatCurrency(price)
    },
    calcDuration() {
      let timeStart = new Date(this.date + " " + this.startTime)
      let timeEnd = new Date(this.date + " " + this.endTime)
      let res = Math.abs(timeEnd - timeStart) / 1000
      let hours = Math.floor(res / 3600) % 24
      return (Math.floor(res / 60) % 60) + (hours * 60)
    },
    addevent() {
      eventService.addEvent(this.selectedField, this.date + " " + this.startTime, this.calcDuration(), this.stateEvent,
          this.minParticipant, this.maxParticipant, this.searchEndDate + " " + this.searchEndTime,
          this.difficulty, this.description, this.title).then(res => {
        if (res.code === 1) {
          this.$root.$bvToast.toast("Das Event wurde erfolgreich erstellt. Glückwunsch du Horst", {
            title: "Erfolgreich erstellt",
            autoHideDelay: 5000,
            variant: "success"
          });
        } else if (res.code === 11) {
          this.$root.$bvToast.toast("Die Angegebene Zeit ist leider nicht mehr Frei. Sad Life", {
            title: "Fehler beim Erstellen",
            autoHideDelay: 5000,
            variant: "danger"
          });
        } else if (res.code === 12) {
          this.$root.$bvToast.toast("Das Feld ist zu der Zeit geschlossen. Sad Life", {
            title: "Fehler beim Erstellen",
            autoHideDelay: 5000,
            variant: "danger"
          });
        } else if (res.code === 13) {
          this.$root.$bvToast.toast("Das Feld wurde nicht gefunden. Sad Life", {
            title: "Fehler beim Erstellen",
            autoHideDelay: 5000,
            variant: "danger"
          });
        } else if (res.code === 16) {
          this.$root.$bvToast.toast("Die Suche muss mindestens einen Tag vorher enden. Sad Life", {
            title: "Fehler beim Erstellen",
            autoHideDelay: 5000,
            variant: "danger"
          });
        } else if (res.code === 17) {
          this.$root.$bvToast.toast("Die Suche muss mindestens eine Stunde andauern. Sad Life", {
            title: "Fehler beim Erstellen",
            autoHideDelay: 5000,
            variant: "danger"
          });
        } else if (res.code === 18) {
          this.$root.$bvToast.toast("Ungültige Schwierigkeit. Sad Life", {
            title: "Fehler beim Erstellen",
            autoHideDelay: 5000,
            variant: "danger"
          });
        } else {
          this.$root.$bvToast.toast(  res.message, {
            title: "Fehler beim Erstellen",
            autoHideDelay: 5000,
            variant: "danger"
          });
        }
      })
    },
    progressStyle(i) {
      return {width: (i <= (this.currentTab + 1)) ? ((100 / this.totalPages) + '%') : '0'}
    },
    formBoxStyle(i) {
      return {transform: (i === this.currentTab) ? "translate(0%)" : (i < this.currentTab) ? "translate(-100%)" : "translate(100%)"}
    },
    nextPrev(n) {

      let val = this.currentTab + n
      if (val >= 0 && val < this.totalPages) {
        this.currentTab = val
      }
    }
  }

}

</script>

<style scoped>
.step-form {
  height: 90vh;
  position: relative;
  overflow: hidden;
}

.step-form .step-formbox {
  position: absolute;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  transition: 0.5s;
}

.step-formbox .step-grid {
  display: grid;
  grid-template-columns: 1fr 3fr;
  justify-items: stretch;
  grid-gap: 10px;
}

.step-formbox .step-descripton, .step-formbox .step-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}

.step-formbox .step-content p {
  margin: 0 10px;
}

.step-form .step-formbox h3 {
  text-align: center;
  margin: 30px 0;
  color: #777;
}

.step-form .step-btns {
  margin: 30px auto;
  display: flex;
  align-items: center;
  text-align: center;
  float: right;
  position: absolute;
  right: 0;
  bottom: 0;
}

.step-form .step-btns button {
  width: 110px;
  height: 35px;
  margin: 0 10px;
  background-color: var(--green);
  border-radius: 30px;
  border: 0;
  color: #fff;
  cursor: pointer;
  padding: inherit;
}

.step-row {
  width: 100%;
}

.progess {
  float: left;
  height: 0;
  border-bottom: 4px solid green;
  width: 0;
  transition: width 1s;
}

input[type="text"], textarea {
  margin-top: inherit;
  margin-bottom: 0;
}

.searchEnd {
  width: 33%;
  margin-right: 20px;
}

.searchEnd:last-child {
  margin-right: 0;
}

.participant {
  width: 40%;
  box-shadow: none;
  border: none;
  height: 40px;
  padding: 0;
  border-bottom: 1px solid #333333;
  border-radius: 0;
}

@media screen and (max-width: 768px) {

}

@media screen and (max-width: 400px) {
  .step-formbox .step-grid {
    grid-template-columns: 1fr;
  }
}
</style>
